import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum DocumentAssignFormSteps {
  AddDetails = "Add Details",
  AssignAnnotations = "Assign Annotations",
  SelectSigningOrder = "Select Signing Order",
  ScheduleDocument = "Schedule Document",
  PublishDocument = "Publish Document",
}

export type DocumentAssignFormState = {
  step: DocumentAssignFormSteps | null;
  documentToEditId: string | null;
  selectedAnnotationId: string | null;
  isAssignDialogOpen: boolean;
};

const initialState: DocumentAssignFormState = {
  step: null,
  documentToEditId: null,
  selectedAnnotationId: null,
  isAssignDialogOpen: false,
};

export const documentAssignFormSlice = createSlice({
  name: "documentAssignForm",
  initialState,
  reducers: {
    resetDocumentAssignFormState: (state) => {
      state.step = null;
      state.documentToEditId = null;
      state.selectedAnnotationId = null;
      state.isAssignDialogOpen = false;
    },
    setDocumentAssignFormStep: (
      state,
      action: PayloadAction<DocumentAssignFormSteps | null>
    ) => {
      state.step = action.payload;
    },
    setDocumentToEditId: (state, action: PayloadAction<string | null>) => {
      state.documentToEditId = action.payload;
    },
    setSelectedAnnotationId: (state, action: PayloadAction<string | null>) => {
      state.selectedAnnotationId = action.payload;
    },
    setIsAssignDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isAssignDialogOpen = action.payload;
    },
  },
});

export const {
  resetDocumentAssignFormState,
  setDocumentAssignFormStep,
  setDocumentToEditId,
  setSelectedAnnotationId,
  setIsAssignDialogOpen,
} = documentAssignFormSlice.actions;

export default documentAssignFormSlice.reducer;
